import React from "react";
import { Row, Container, Col, Form, Button, Modal } from "react-bootstrap";

const CasePreview = (props) => {
    const { show, closeModal } = props;

    const closePreviewModal = () => {
        closeModal();
    }
    return (
        <Modal id="" show={show} animation={true} scrollable={true} size="lg">
            <Modal.Header closeButton onClick={() => closePreviewModal()}></Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Row>
                        <Col lg='4'>
                            <Form.Group>
                                <Form.Label>Schedule</Form.Label>
                                <Form.Control as="select" id="" name='schedule' disabled>
                                    <option value="DEFAULT">- Select Schedule -</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Premedications</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='premedications' disabled/>
                            </Form.Group>
                        </Col>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Special Instruction to Nurse</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='instructNurse' disabled/>
                            </Form.Group>
                        </Col>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Special Instruction to Patients</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='instructPatient' disabled/>
                            </Form.Group>
                        </Col>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Next Visit Instructions</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='nextVisit' disabled/>
                            </Form.Group>
                        </Col>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Drug Interactions</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='drugInteraction' disabled/>
                            </Form.Group>
                        </Col>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Special Tests (if any)</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='specialTest' disabled/>
                            </Form.Group>
                        </Col>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Adverse Events</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='adverseEvent' disabled/>
                            </Form.Group>
                        </Col>
                        <Col lg='6'>
                            <Form.Group>
                                <Form.Label>Risk of Death</Form.Label>
                                <Form.Control as='textarea' placeholder='' rows={2} name='riskDeath' disabled/>
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col lg='12' className='text-center'>
                        <Button className="btn-primary btn btn-secondary"> Print </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}

export default CasePreview;